module.exports = __webpack_public_path__ + "img/pexels-wendy-wei-2723118.650340b5.jpg";